<template>
  <div class="h-100 position-relative">
    <!-- <div class="noLogin" v-if="!userInfo.avatar" @click="toLogin">
      当前为游客模式,授权享受更多精彩服务 <span>立即授权</span>
    </div> -->
    <div
      class="follow"
      v-if="follow !== '' && tabIndex === 0"
      @click="toFollow"
    >
      点击进入公众号 获取更多精彩
    </div>
    <div
      v-if="tabBars"
      :class="[
        'root',
        { overHeight: tabBars[tabIndex].page.code != 'cate' },
        { root2: !userInfo.avatar },
      ]"
    >
      <div v-for="(item, index) in tabBars" :key="index">
        <page-cate
          :showPaddingBottom="true"
          ref="cate"
          v-if="item.page.code == 'cate'"
          v-show="tabIndex == index"
        />
        <page-base
          ref="base"
          :modules="item.page.modules"
          v-if="item.page.code == 'base'"
          v-show="tabIndex == index"
        />
        <page-cart
          ref="cart"
          v-if="item.page.code == 'cart'"
          v-show="tabIndex == index"
        />
        <page-user
          ref="user"
          v-if="item.page.code == 'user'"
          v-show="tabIndex == index"
        />
        <page-live
          ref="live"
          v-if="item.page.code == 'live'"
          v-show="tabIndex == index"
        />
        <search
          ref="allProduct"
          v-if="item.page.code == 'allProduct'"
          v-show="tabIndex == index"
        />
      </div>
      <div :style="{ height: '65px' }"></div>
    </div>
    <van-tabbar v-model="tabIndex" @change="tanBarClick" class="me-tabbar">
      <van-tabbar-item v-for="(item, index) in tabBars" :key="index">
        <span
          :style="[
            { color: tabIndex == index ? item.selectColor : item.color },
          ]"
          >{{ item.text }}</span
        >
        <template #icon="props">
          <img :src="props.active ? item.selectIcon : item.icon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {myMixins} from '@/mixins'
import { mapMutations, mapState } from "vuex";
import search from "@/views/pages/search/search.vue";
export default {
  needShare: true,
  components: { search },
  data() {
    return {
    };
  },
  mixins:[myMixins],
  computed: {
    ...mapState(["hasLogin", "userInfo", "openId", "config", "follow"]),
    tabBars: function () {
      return this.$store.getters.config.tabBars;
    },
    tabIndex: {
      get() {
        return this.$store.getters.config.tabIndex;
      },
      set(val) {
        const config = this.$store.getters.config;
        config.tabIndex = val;
        this.setConfig(config);
      },
    },
  },
  created() {
    
  },
  mounted() {},
  watch: {
    $route: {
      handler(val, Val) {
        console.log(val, Val);
        console.log(this);
        if (val.query.code) {
          let itm;
          if (val.query.code == "购物车" || val.query.code == "首页") {
            if (this.tabBars) {
              this.tabBars.forEach((item, index) => {
                if (item.title === val.query.code) {
                  this.tabIndex = index;
                  itm = item;
                }
              });
            }
          } else {
            this.tabIndex = parseFloat(val.query.code);
            itm = this.tabBars[this.tabIndex];
          }
          if (itm && itm.page) {
            const refs = this.$refs[itm.page.code];
            for (let ref of refs) {
              if (ref.loadData) {
                ref.loadData();
              }
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapMutations([
      "login",
      "setOpenId",
      "setConfig",
      "setOrgInfo",
      "setdomain",
      "setFollow",
    ]),
    toFollow() {
      window.location.href = `https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=${this.follow}&scene=110#wechat_redirect`;
    },
    tanBarClick(index) {
      if (this.userInfo.avatar == null || this.userInfo.avatar == '' || this.userInfo.avatar == undefined || this.userInfo.avatar == 'null') {
        this.toLogin();
      }
      this.tabIndex = index;
      const item = this.tabBars[index];
      console.log(this.tabBars);
      const refs = this.$refs[item.page.code];
      for (let ref of refs) {
        if (ref.loadData) {
          ref.loadData();
        }
        if (ref.loadCateList) {
          ref.loadCateList();
        }
      }
    },
    toLogin() {
      //   let redirectUrl = this.$route.path || "/"
      // alert('redirectUrl'+redirectUrl)
      // this.$router.push({
      //   path: "/pages/WechatAuth",
      //   query: {
      //     redirectUrl,
      //   },
      // });
      this.$router.push({
        path: "/pages/WechatAuth",
        query: {
          redirectUrl: this.$route.fullPath || "/",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.root2 {
  top: 40px;
}
.noLogin {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  z-index: 999;
  color: #fff;
  background: purple;
  text-align: center;
  line-height: 40px;
  span {
    padding: 5px;
    border-radius: 10px;
    font-size: 12px;
    background: #fff;
    color: purple;
  }
}
.follow {
  position: fixed;
  top: 50px;
  right: 0;
  width: 130px;
  background: rgba(255, 255, 255, 0.3);
  color: orange;
  text-align: center;
  z-index: 999999;
}
.overHeight {
  overflow-y: scroll;
}
.overHeight::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.tabbar {
  height: 50px;
  width: 100%;
  background-color: white;
  border-top: 1px $uni-border-color solid;
  position: fixed;
  bottom: 0;
  left: 0;

  img {
    height: 25px;
    width: 25px;
  }

  span {
    font-size: $uni-font-size-sm;
  }
}
.me-tabbar {
  padding-bottom: 20px;
  overflow: hidden;
}
</style>
